import reducer from "./reducers";

export { default as loyaltyOperations } from "./operations";

export default reducer
